export default __webpack_public_path__ + "static/media/arrow-black.c781ab8e.svg";